<template>
  <div class="loader" :class="getSizeClass"></div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: String,
  },
  computed: {
    getSizeClass() {
      switch (this.size) {
        case 'sm':
          return 'loader--sm';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped>
.loader {
  border: 0.375rem solid var(--gray-color-300);
  border-top: 0.375rem solid var(--main-color-500);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.5s linear infinite;
}

.loader--sm {
  border-width: 3px;
  border-top-width: 3px;
  width: 18px;
  height: 18px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
